import { render, staticRenderFns } from "./Step4Characteristics.vue?vue&type=template&id=0f38f238&scoped=true"
import script from "./Step4Characteristics.vue?vue&type=script&lang=js"
export * from "./Step4Characteristics.vue?vue&type=script&lang=js"
import style0 from "./Step4Characteristics.vue?vue&type=style&index=0&id=0f38f238&prod&lang=css"
import style1 from "./Step4Characteristics.vue?vue&type=style&index=1&id=0f38f238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f38f238",
  null
  
)

export default component.exports